import { post, patch } from '../../../../infra/rest';

export const unassignChat = async (chatId: string): Promise<boolean> => {
  if (!chatId) return false;

  await patch<{ success: boolean }>(
    `/v1/conversation/${chatId}/unassign`,
    {},
    true
  );

  return true;
};

export const unassignMultipleChats = async (
  chatIds: string[]
): Promise<boolean> => {
  if (!chatIds || chatIds.length === 0) return false;

  await patch<{ success: boolean }>(
    `/v1/conversation/unassign-multiple-chats`,
    {
      body: JSON.stringify({ chatIds }),
    },
    true
  );

  return true;
};
